import {
    SYSTEM_ALT_LOG_LAST_READING_INFO_OPEN_MODAL,
    SYSTEM_ALT_LOG_LAST_READING_INFO_REQUEST,
    SYSTEM_ALT_LOG_LAST_READING_INFO_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    openModal: false,
    device: null,
    loading: false,
    result: null,
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case SYSTEM_ALT_LOG_LAST_READING_INFO_OPEN_MODAL:
            return { ...state, openModal: action.payload.open, device: action.payload.device }

        case SYSTEM_ALT_LOG_LAST_READING_INFO_REQUEST:
            return { ...state, loading: true }

        case SYSTEM_ALT_LOG_LAST_READING_INFO_RESULT:
            return { ...state, loading: false, result: action.payload }

        case CLEAR_REDUX:
            return ["", "SYSTEM_ALT_LAST_READING_INFO"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};